import React from "react"
import ReactDOM from "react-dom"
import MovingGraphicBlockComponent from "./moving-graphic-block-component.jsx"

export default class MovingGraphicBlockModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<MovingGraphicBlockComponent {...this.modelJson} />, self.elem)
  }
}
